var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "16px",
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Grid View") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.2421875,14.6607812 C5.07061462,14.6607812 5.7421875,15.3323541 5.7421875,16.1607812 L5.7421875,18.0826562 C5.7421875,18.9110834 5.07061462,19.5826562 4.2421875,19.5826562 L2.3203125,19.5826562 C1.49188538,19.5826562 0.8203125,18.9110834 0.8203125,18.0826562 L0.8203125,16.1607812 C0.8203125,15.3323541 1.49188538,14.6607812 2.3203125,14.6607812 L4.2421875,14.6607812 Z M13.0840625,14.6607812 C13.9124896,14.6607812 14.5840625,15.3323541 14.5840625,16.1607812 L14.5840625,18.0826562 C14.5840625,18.9110834 13.9124896,19.5826562 13.0840625,19.5826562 L11.1621875,19.5826562 C10.3337604,19.5826562 9.6621875,18.9110834 9.6621875,18.0826562 L9.6621875,16.1607812 C9.6621875,15.3323541 10.3337604,14.6607812 11.1621875,14.6607812 L13.0840625,14.6607812 Z M21.9259375,14.6607812 C22.7543646,14.6607812 23.4259375,15.3323541 23.4259375,16.1607812 L23.4259375,18.0826562 C23.4259375,18.9110834 22.7543646,19.5826562 21.9259375,19.5826562 L20.0040625,19.5826562 C19.1756354,19.5826562 18.5040625,18.9110834 18.5040625,18.0826562 L18.5040625,16.1607812 C18.5040625,15.3323541 19.1756354,14.6607812 20.0040625,14.6607812 L21.9259375,14.6607812 Z M4.2421875,4.81703125 C5.07061462,4.81703125 5.7421875,5.48860413 5.7421875,6.31703125 L5.7421875,8.23890625 C5.7421875,9.06733337 5.07061462,9.73890625 4.2421875,9.73890625 L2.3203125,9.73890625 C1.49188538,9.73890625 0.8203125,9.06733337 0.8203125,8.23890625 L0.8203125,6.31703125 C0.8203125,5.48860413 1.49188538,4.81703125 2.3203125,4.81703125 L4.2421875,4.81703125 Z M13.0840625,4.81703125 C13.9124896,4.81703125 14.5840625,5.48860413 14.5840625,6.31703125 L14.5840625,8.23890625 C14.5840625,9.06733337 13.9124896,9.73890625 13.0840625,9.73890625 L11.1621875,9.73890625 C10.3337604,9.73890625 9.6621875,9.06733337 9.6621875,8.23890625 L9.6621875,6.31703125 C9.6621875,5.48860413 10.3337604,4.81703125 11.1621875,4.81703125 L13.0840625,4.81703125 Z M21.9259375,4.81703125 C22.7543646,4.81703125 23.4259375,5.48860413 23.4259375,6.31703125 L23.4259375,8.23890625 C23.4259375,9.06733337 22.7543646,9.73890625 21.9259375,9.73890625 L20.0040625,9.73890625 C19.1756354,9.73890625 18.5040625,9.06733337 18.5040625,8.23890625 L18.5040625,6.31703125 C18.5040625,5.48860413 19.1756354,4.81703125 20.0040625,4.81703125 L21.9259375,4.81703125 Z",
    id: "path-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-grid",
    transform: "translate(0.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layout-module",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(0.000000, 4.000000)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color-/-Default",
    mask: "url(#mask-4)",
    fill: "#000000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.eae2e034b82a29b4c66cd943977f49a7.svg";
export { ForwardRef as ReactComponent };